import { render, staticRenderFns } from "./drawConfig.vue?vue&type=template&id=469a7bc2&scoped=true"
import script from "./drawConfig.vue?vue&type=script&lang=js"
export * from "./drawConfig.vue?vue&type=script&lang=js"
import style0 from "./drawConfig.vue?vue&type=style&index=0&id=469a7bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469a7bc2",
  null
  
)

export default component.exports